import { useDeviceType } from '@cian/ui-kit';
import { deleteCookie } from '@cian/utils/lib/browser/cookie';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getDateRangeValue } from '../../../../../packages/JsonQuery';
import { openDatesModal } from '../../../actions/filters/datesModal';
import { COOKIE_NAME } from '../../../constants/datesModal';
import { selectResultsJsonQuery } from '../../../selectors/results';
import { TThunkDispatch } from '../../../types/redux';
import { useDatesAutoSetExperimentActive } from '../../../utils/experiments/datesAutoSet';
import { useApplicationContext } from '../../ApplicationContext';
import { trackAutoOpenDatesModal } from '../tracking';

export function useDatesModalAutoOpen() {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();

  const isDatesModalAutoOpenRSEnabled = config.get<boolean>('Dailyrent.DatesAutoOpen.Enabled');
  const isDatesAutoSetEnabled = useDatesAutoSetExperimentActive();

  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const jsonQuery = useSelector(selectResultsJsonQuery);
  const { gte, lt } = getDateRangeValue('dates')(jsonQuery) || {};
  const hasDates = Boolean(gte && lt);

  React.useEffect(() => {
    const hasSkipCookie = document.cookie.includes(COOKIE_NAME);

    if (hasSkipCookie) {
      deleteCookie(COOKIE_NAME);
    }

    if (!isDatesAutoSetEnabled && isDatesModalAutoOpenRSEnabled && isMobile && !hasDates && !hasSkipCookie) {
      trackAutoOpenDatesModal();
      dispatch(openDatesModal());
    }
  }, []);
}
